import React from "react";

const CapabilityNode = ({ label, value, detail, color }) => {
    return (
        <div style={{
            background: "rgba(255,255,255,0.015)", border: "1px solid rgba(255,255,255,0.06)",
            padding: "35px", borderRadius: "2px", transition: "all 0.3s",
            display: "flex", flexDirection: "column", gap: "12px", position: "relative"
        }}
        onMouseEnter={e => { e.currentTarget.style.borderColor = color; e.currentTarget.style.background = `${color}05`; }}
        onMouseLeave={e => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.06)"; e.currentTarget.style.background = "rgba(255,255,255,0.015)"; }}
        >
            <div style={{ fontSize: "10px", color: color, fontFamily: "monospace", letterSpacing: "2px" }}>CAP_SPEC_{label.toUpperCase().replace(/\s/g, '_')}</div>
            <div style={{ fontSize: "28px", color: "#fff", fontFamily: "'Conthrax', sans-serif", letterSpacing: "-1px" }}>{value.toUpperCase()}</div>
            <div style={{ fontSize: "12px", color: color, opacity: 0.8, fontWeight: "bold" }}>{label.toUpperCase()}</div>
            <div style={{ fontSize: "14px", color: "rgba(255,255,255,0.4)", lineHeight: 1.5, marginTop: "10px" }}>{detail}</div>
            
            {/* Corner Decor */}
            <div style={{ position: "absolute", bottom: "10px", right: "10px", width: "10px", height: "10px", borderRight: `1px solid ${color}`, borderBottom: `1px solid ${color}` }} />
        </div>
    );
};

function Speciality({ content }) {
  const { color, id, capabilities } = content;

  return (
    <section id="platform" style={{
      padding: "160px 30px", background: "#010108", position: "relative", overflow: "hidden"
    }}>
      <div style={{ maxWidth: "1400px", margin: "0 auto", position: "relative", zIndex: 1 }}>
        <div style={{ textAlign: "center", marginBottom: "100px" }}>
            <span style={{ 
                background: `${color}15`, color: color, padding: "8px 24px", 
                borderRadius: "2px", fontSize: "11px", fontFamily: "monospace", letterSpacing: "5px",
                border: `1px solid ${color}30`
            }}>TECHNICAL_SPECIFICATIONS_V4</span>
            
            <h2 style={{
                fontSize: "clamp(35px, 5vw, 60px)", fontFamily: "'Conthrax', sans-serif",
                color: "#fff", margin: "30px 0", lineHeight: 1.1, textTransform: "uppercase"
            }}>
                Real-time <br />
                <span style={{ color: color }}>Intelligence Mining</span>
            </h2>
            <p style={{ color: "rgba(255,255,255,0.3)", fontFamily: "monospace", fontSize: "13px", maxWidth: "700px", margin: "0 auto" }}>
                >> DEPLOYING OPTIMIZED ANALYTICS PROTOCOLS. SHOWING MISSION-CRITICAL PERFORMANCE METRICS AND OPERATIONAL CAPABILITIES FOR {id.toUpperCase()} HUB...
            </p>
        </div>

        {/* Capability Matrix Grid */}
        <div style={{ 
            display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))", 
            gap: "20px", position: "relative"
        }}>
            {capabilities.map((cap, i) => (
                <CapabilityNode key={i} {...cap} color={color} />
            ))}
        </div>

        {/* System Summary Footer */}
        <div style={{ 
            marginTop: "60px", padding: "30px", background: "rgba(255,255,255,0.01)", 
            border: "1px solid rgba(255,255,255,0.05)", display: "flex", justifyContent: "space-between",
            fontFamily: "monospace", fontSize: "11px", color: "rgba(255,255,255,0.2)"
        }}>
             <div style={{ display: "flex", gap: "30px" }}>
                 <div>NODE_STATUS: <span style={{ color: "#10B981" }}>SYNCHRONIZED</span></div>
                 <div>LATENCY: <span style={{ color: color }}>0.012ms_P50</span></div>
                 <div>THROUGHPUT: <span style={{ color: color }}>OPTIMAL</span></div>
             </div>
             <div style={{ color: color }}>AUTHENTICATED_SECURE_ACCESS_ESTABLISHED</div>
        </div>
      </div>
    </section>
  );
}

export default Speciality;